import { JwtServiceInterface } from '../models/jwt.service.interface';
import { InjectionToken } from '@angular/core';

export const JWT_SERVICE_TOKEN = new InjectionToken<JwtServiceInterface>('JWT_SERVICE_TOKEN');

export const HEADER_SKIP_REFRESH_TOKEN = 'X-Skip-Refresh-Token';
